export const HEADER_HEIGHT = "64px";
export const FOOTER_HEIGHT = "77px";
export const PAGE_PADDING = "24px";

export const generateTableHeight = (adjustmentHeight: string) => {
  return `calc(100vh - ${adjustmentHeight} - ${HEADER_HEIGHT} - ${FOOTER_HEIGHT} - ${PAGE_PADDING})`;
};
